import React from 'react'

const AIPoweredRouteIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 16.933 16.933"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <path
                        fill="#e4eff8"
                        d="M.72 2.405a.522.522 0 0 0-.19.386v13.057c0 .159.059.294.163.404.105.11.302.195.49.129 1.579-.558 3.324-1.116 4.902-1.674l4.944 1.684a.265.265 0 0 0 .085.013h5.025a.265.265 0 0 0 .265-.265V2.646a.265.265 0 0 0-.265-.265h-4.981L6.085.529c-.033-.012-5.08 1.729-5.08 1.729a.917.917 0 0 0-.284.147z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#c4dcf0"
                        d="M6.085.53c-.033-.013-5.08 1.728-5.08 1.728a.917.917 0 0 0-.284.147.522.522 0 0 0-.192.386v13.057c0 .159.06.294.164.404.105.11.302.195.49.129 1.579-.558 3.324-1.116 4.902-1.674z"
                        opacity={1}
                        data-original="#c4dcf0"
                        className="hovered-path"
                    />
                    <path
                        fill="#ff9751"
                        d="M12.965 7.031c-1.315 0-2.381 1.09-2.381 2.42 0 .913.565 1.875 1.107 2.639a12.767 12.767 0 0 0 1.082 1.324.265.265 0 0 0 .381 0s.542-.56 1.084-1.324 1.108-1.726 1.108-2.639c0-1.33-1.066-2.42-2.38-2.42z"
                        opacity={1}
                        data-original="#ff9751"
                    />
                    <path
                        fill="#e4eff8"
                        d="M12.965 8.426c-.53 0-.97.433-.97.963s.44.96.97.96c.531 0 .97-.43.97-.96s-.439-.963-.97-.963z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#38668c"
                        d="M11.114 4.233c-.353 0-.353.53 0 .53h.528c.353 0 .353-.53 0-.53zM12.701 4.233c-.353 0-.353.53 0 .53h.528c.353 0 .353-.53 0-.53zM14.288 4.233c-.353 0-.353.53 0 .53h.529c.353 0 .353-.53 0-.53z"
                        opacity={1}
                        data-original="#38668c"
                    />
                    <path
                        fill="#ff9751"
                        d="M7.938 7.673c.352 0 .352-.53 0-.53H6.879c-.353 0-.353.53 0 .53z"
                        opacity={1}
                        data-original="#ff9751"
                    />
                    <path
                        fill="#ff9751"
                        d="M7.144 7.937c0 .353.53.353.53 0V6.88c0-.353-.53-.353-.53 0z"
                        opacity={1}
                        data-original="#ff9751"
                    />
                    <path
                        fill="#ff7f29"
                        d="M4.498 11.642c.353 0 .353-.53 0-.53H3.44c-.353 0-.353.53 0 .53z"
                        opacity={1}
                        data-original="#ff7f29"
                    />
                    <path
                        fill="#ff7f29"
                        d="M3.704 11.906c0 .353.53.353.53 0v-1.058c0-.353-.53-.353-.53 0z"
                        opacity={1}
                        data-original="#ff7f29"
                    />
                    <path
                        fill="#ff9751"
                        d="M3.705.53c-1.024 0-1.853.857-1.853 1.898 0 .719.432 1.451.841 2.035.41.583.82 1.012.82 1.012a.265.265 0 0 0 .381 0s.411-.429.821-1.012c.41-.584.842-1.316.842-2.035 0-1.041-.828-1.899-1.852-1.899z"
                        opacity={1}
                        data-original="#ff9751"
                    />
                    <path
                        fill="#e4eff8"
                        d="M3.705 1.588a.799.799 0 0 0-.795.793.795.795 0 0 0 1.588 0 .796.796 0 0 0-.793-.793z"
                        opacity={1}
                        data-original="#e4eff8"
                    />
                    <path
                        fill="#ff7f29"
                        d="M2.702.835c-.511.34-.85.928-.85 1.593 0 .719.432 1.451.841 2.035.41.583.82 1.012.82 1.012a.265.265 0 0 0 .381 0s.17-.183.394-.455a.265.265 0 0 1-.245-.075s-.41-.428-.82-1.011c-.41-.584-.842-1.317-.842-2.035 0-.393.118-.76.32-1.064z"
                        opacity={1}
                        data-original="#ff7f29"
                    />
                    <path
                        fill="#c4dcf0"
                        d="M2.947 2.155a.778.778 0 0 1 .229-.038c.435 0 .793.358.793.793a.772.772 0 0 1-.037.225.792.792 0 0 0 .566-.754.796.796 0 0 0-.793-.793.798.798 0 0 0-.758.567zM12.066 9.029a.971.971 0 0 1 1.34.889.94.94 0 0 1-.072.358.965.965 0 0 0 .602-.887.971.971 0 0 0-1.87-.36z"
                        opacity={1}
                        data-original="#c4dcf0"
                        className="hovered-path"
                    />
                    <path
                        fill="#ff7f29"
                        d="M11.585 7.484a2.43 2.43 0 0 0-1.001 1.967c0 .913.565 1.875 1.107 2.639a12.767 12.767 0 0 0 1.082 1.324.265.265 0 0 0 .381 0s.17-.179.407-.457a.265.265 0 0 1-.258-.072s-.54-.56-1.083-1.324c-.542-.764-1.107-1.726-1.107-2.64 0-.537.177-1.034.472-1.437z"
                        opacity={1}
                        data-original="#ff7f29"
                    />
                    <g fill="#38668c">
                        <path
                            d="M4.762 5.557h.529v-.53h-.53zM5.82 5.557h.53v-.53h-.53zM6.879 5.557h.53v-.53h-.53zM7.937 5.557h.125c.188 0 .267.02.352.033l.101-.52a2.28 2.28 0 0 0-.445-.043h-.133zM8.843 5.738c.04.021.113.059.193.115.08.055.137.099.186.144l.354-.395a2.608 2.608 0 0 0-.242-.189 2.652 2.652 0 0 0-.252-.147zM9.518 6.345c.015.02.069.112.116.212.046.1.077.203.077.203l.505-.16a2.495 2.495 0 0 0-.103-.269 2.855 2.855 0 0 0-.15-.274zM9.782 7.437c-.009.106-.026.178-.036.231l.516.115c.053-.231.058-.413.056-.533l-.001-.063c-.217.012-.367.017-.529.02.002.077.003.124-.006.23zM9.315 8.465l.386.363c.073-.08.117-.13.163-.193.027-.039.041-.054.085-.121.047-.07.07-.114.103-.17l-.467-.25a1.653 1.653 0 0 1-.133.207c-.045.064-.075.097-.137.164zM8.745 8.858c-.09.04-.162.058-.204.073l.142.51s.123-.032.272-.095c.158-.068.278-.143.278-.143l-.272-.455c-.058.036-.126.07-.216.11z"
                            fill="#38668c"
                            opacity={1}
                            data-original="#38668c"
                        />
                    </g>
                    <path
                        fill="#2c5170"
                        d="M3.4 9.58a1.78 1.78 0 0 1 .458-.056 60.937 60.937 0 0 1 0-.528 2.234 2.234 0 0 0-.593.073zM4.385 9.525h.53v-.529h-.53zM5.444 9.525h.53v-.529h-.53z"
                        opacity={1}
                        data-original="#2c5170"
                    />
                    <path
                        fill="#38668c"
                        d="M6.503 9.525h.529v-.529h-.53zM7.56 9.525h.532c-.003-.205-.003-.353-.003-.529H7.56z"
                        opacity={1}
                        data-original="#38668c"
                    />
                    <path
                        fill="#2c5170"
                        d="M2.237 9.658c.132.133.252.25.378.374.104-.106.217-.195.362-.28l-.265-.457c-.2.117-.339.233-.475.363zM1.655 10.692l.515.13c.028-.133.097-.302.169-.425l-.461-.26c-.106.18-.183.39-.223.555zM1.587 11.285c.007.202.032.392.089.591l.509-.147a1.67 1.67 0 0 1-.067-.454zM1.92 12.423c.105.174.242.342.377.464l.363-.386a1.698 1.698 0 0 1-.29-.355zM2.782 13.233c.256.133.457.185.564.207l.115-.517a1.708 1.708 0 0 1-.43-.156zM3.929 13.494h.527v-.53h-.527zM4.987 13.494h.53v-.53h-.53z"
                        opacity={1}
                        data-original="#2c5170"
                    />
                    <path
                        fill="#38668c"
                        d="M6.045 13.494h.53v-.53h-.53zM7.104 13.494h.53v-.53h-.53zM8.162 13.494h.53v-.53h-.53zM9.22 13.494h.53v-.53h-.53zM10.28 13.494h.53v-.53h-.53zM11.337 13.494h.545v-.53h-.545z"
                        opacity={1}
                        data-original="#38668c"
                    />
                </g>
            </svg>

        </>
    )
}

export default AIPoweredRouteIcon